<template>
  <header class="site-header">
    <div class="site-header__inner">
      <router-link class="brand" to="/">
        <!-- <img alt="logo" class="brand__logo" src="@/assets/logo.png">
        <div class="brand__text">
          <strong>新网软件</strong>
          <span>运营商互联网信息服务</span>
        </div> -->
      </router-link>

      <!-- <el-tabs
        :model-value="activeTab"
        class="nav-tabs"
        @tab-change="handleTabChange"
      >
        <el-tab-pane label="首页" name="/" />
        <el-tab-pane label="登录" name="/login" />
      </el-tabs> -->
      <div class="login" @click="router.push('/login')">
        登录
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const activeTab = computed(() => {
  if (route.path === '/login' || route.path === '/register' || route.path === '/profile') {
    return '/login'
  }

  return '/'
})

function handleTabChange(name) {
  router.push(name)
}
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 30;
  backdrop-filter: blur(14px);
  background: rgba(243, 247, 252, 0.88);
  background-size: 100%;
  border-bottom: 1px solid rgba(17, 88, 214, 0.08);
}

.site-header__inner {
  width: min(1400px, calc(100% - 48px));
  margin: 0 auto;
  min-height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.brand {
  display: block;
  // display: flex;
  // align-items: center;
  gap: 12px;
  width: 200px;
  height: 57px;
  background: url('../assets/logo.png') no-repeat center center;
  background-size: cover;
}

.brand__logo {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(17, 88, 214, 0.16);
}

.brand__text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.brand__text strong {
  font-size: 18px;
  line-height: 1;
  color: var(--text-main);
}

.brand__text span {
  font-size: 12px;
  color: var(--text-secondary);
}

:deep(.nav-tabs .el-tabs__header) {
  margin: 0;
}

:deep(.nav-tabs .el-tabs__nav-wrap::after) {
  display: none;
}

:deep(.nav-tabs .el-tabs__item) {
  height: 42px;
  line-height: 42px;
  font-size: 15px;
  color: var(--text-secondary);
}

:deep(.nav-tabs .el-tabs__item.is-active) {
  color: var(--primary);
  font-weight: 700;
}

:deep(.nav-tabs .el-tabs__active-bar) {
  background-color: var(--primary);
  height: 3px;
  border-radius: 999px;
}

@media (max-width: 768px) {
  .site-header__inner {
    width: calc(100% - 24px);
    min-height: 72px;
    flex-direction: column;
    justify-content: center;
    padding: 10px 0 14px;
    gap: 10px;
  }

  .brand__text strong {
    font-size: 16px;
  }
}
.login {
  cursor: pointer;
}
.login:hover {
  color: #00C9FF;
}
</style>
